<template>
  <div class="processing-tool-content">
    <ProcessingExpansionPanel
      v-for="(process, index) in processingItems"
      :key="pr_code + process.pr_code + index"
      :processing="process"
      :processIndex="index"
      @run-processing="runProcessing($event)"
      @change-to-default="$emit('change-to-default', $event)"
    />
  </div>
</template>

<script>
import ProcessingButton from "@/components/Home/Content/ObjectWindow/Processing/ProcessingButton";
import ProcessingExpansionPanel from "@/components/Home/Content/ObjectWindow/Processing/ProcessingExpansionPanel";
export default {
  name: "ProcessingList",

  components: { ProcessingExpansionPanel, ProcessingButton },

  props: {
    processingItems: {
      type: Array,
      required: true
    },

    pr_code: {
      type: String
    }
  },

  methods: {
    /**
     * Emits an event to run processing
     */
    runProcessing(data) {
      this.$emit("run-processing", data);
    }
  }
};
</script>
<style scoped>
.processing-tool-content {
  font-size: 12px !important;
  max-height: 656px !important;
  padding: 10px 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/Processing/ProcessingList.vue